import { jsx as _jsx } from "react/jsx-runtime";
import IdViewer from "@/components/IdViewer";
import { deleteTenant } from "@/utils/string";
import { MoreOutlined } from "@ant-design/icons";
import { Badge, Button } from "@atom/ui-kit";
import { Dropdown, Menu, Space } from "antd";
import { startCase } from "lodash";
import PlayerEditDrawer from "./edit/PlayerEditDrawer";
export var columns = function (handleEdit, t) { return [
    {
        title: t("playerManagement.columns.lobby"),
        dataIndex: "lobbyId",
        key: "lobbyId",
        width: 60,
        render: function (lobbyId) { return _jsx(IdViewer, { id: lobbyId }); },
    },
    {
        title: t("playerManagement.columns.player_id"),
        dataIndex: "username",
        key: "username",
        width: 40,
        render: function (username) { return _jsx(IdViewer, { id: deleteTenant(username), length: 12, justify: "space-between" }); },
    },
    { title: t("playerManagement.columns.player_name"), dataIndex: "nickname", key: "nickname", width: 80 },
    {
        title: t("playerManagement.columns.risk_group"),
        dataIndex: "risk_group",
        key: "risk_group",
        width: 80,
        render: function (riskGroup) { return (riskGroup ? riskGroup : "N/A"); },
    },
    { title: t("playerManagement.columns.created_date"), dataIndex: "created_date", key: "created_date", width: 80, render: function (createdDate) { return (createdDate ? createdDate : "N/A"); } },
    {
        title: t("playerManagement.columns.account_status"),
        dataIndex: "blockStatus",
        key: "blockStatus",
        width: 60,
        render: function (blockStatus) { return (blockStatus ? _jsx(Badge, { badgeType: "outline", defaultColor: blockStatus === "active" ? "SuccessDefault" : "ErrorDefault", text: startCase(blockStatus) }) : "N/A"); },
    },
    {
        title: "Action",
        dataIndex: "action",
        key: "action",
        width: 40,
        fixed: "right",
        render: function (_, record) {
            var menu = (_jsx(Menu, { children: _jsx(Menu.Item, { children: _jsx(PlayerEditDrawer, { data: record, trigger: _jsx(Space, { children: _jsx("p", { style: {
                                    width: "100px",
                                }, children: t("root.edit_button") }) }) }) }, "edit") }));
            return (_jsx(Dropdown, { overlay: menu, trigger: ["click"], children: _jsx(Button, { buttonSize: "small", buttonType: "primary", icon: _jsx(MoreOutlined, {}), children: t("root.actions_button") }) }));
        },
    },
]; };
